import createCachedSelector from 're-reselect';

import { getInnerLineScoresConf } from 'app/configs/matchScores';
import { MATCH_PERIODS_BY_SPORT, MATCH_TOTAL_SCORES_TYPE_BY_SPORT } from 'app/lib/betting/constants';

export default (matchSportId, matches, isMatchStarted) => {
  /**
   * @param {object} state
   * @param {number} lineId
   * @param {number} matchId
   * @return {Immutable.Map<number, number>}
   */
  const innerLinesScores = createCachedSelector(
    (state, lineId, matchId) => {
      const sportId = matchSportId(state, { matchId });

      return getInnerLineScoresConf(sportId, lineId);
    },
    (state, lineId, matchId) => matches(state).get(matchId).scores,
    (lineScoresConf, scores) => {
      if (!(lineScoresConf && scores)) {
        return null;
      }

      const { scoreType, periodType, periodNumber } = lineScoresConf;

      return scores.getIn([scoreType, periodType, periodNumber]) || null;
    },
  )((state, lineId, matchId) => `${matchId}.${lineId}`);

  /**
   * Create "match main scores" selector.
   *
   * @return {function(state:object):(Immutable.Map<number, number>|null)}
   */
  const matchMainScoresSelector = createCachedSelector(
    (state, matchId) => isMatchStarted(state, { matchId }),
    (state, matchId) => matchSportId(state, { matchId }),
    (state, matchId) => matches(state).get(matchId).scores,
    /**
     * @param {boolean} started
     * @param {number} sportId
     * @param {Immutable.Map<number, any>} scores
     * @return {Immutable.Map<number, number>|null}
     */
    (started, sportId, scores) => {
      if (!(sportId && scores && started)) {
        return null;
      }

      const pointScores = scores.get(MATCH_TOTAL_SCORES_TYPE_BY_SPORT[sportId]);
      const periodScores = pointScores && pointScores.get(MATCH_PERIODS_BY_SPORT[sportId]);

      return periodScores ? periodScores.get(0) : null;
    },
  )((state, matchId) => matchId);

  return { innerLinesScores, matchMainScoresSelector };
};
